<template>
  <div>
    <Gnb :headers="headers" />
    <div class="contents">
      <router-view />
    </div>
    <div id="footer">
      <pinx-footer class="webFooter"></pinx-footer>
      <PinxFooterMobile :class="{mobileFooter: !isReservation, hidden: isReservation}"></PinxFooterMobile>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar';
import PinxFooter from '@/components/PinxFooter';
import PinxFooterMobile from '@/components/PinxFooter_mobile';
import Gnb from '@/components/Gnb';
import GnbDownMenu from '@/components/GnbDownMenu';
import GeneralUtil from '@/util/GeneralUtil';
import {isGolfReservEnter} from '@/util/GolfUtil';

export default {
  components: {Gnb, PinxFooter, PinxFooterMobile},
  mixins: [GeneralUtil],
  data() {
    return {
      isReservation: false,
      isLang: true,
      headers: null,
      headers_ko: [
        {
          topMenu: 'ABOUT',
          // topMenu: '클럽소개',
          subMenu: [
            {
              link: '/p/introduce',
              text: '클럽소개',
              /*text: this.$t('menu1'),*/
            },
            {
              link: '/p/Awards',
              text: '어워즈',
            },
            {
              link: '/p/Tournament',
              text: '토너먼트',
            },
            {
              link: '/p/Notice',
              text: '공지사항',
            },
            {
              link: '/p/Newsroom',
              text: '뉴스룸',
            },
            {
              link: '/p/Photoview',
              text: 'LOCATION',
            },
          ],
        },
        {
          topMenu: 'OPERATION GUIDE',
          // topMenu: '이용안내',
          subMenu: [
            {
              link: '/p/Infoguidance',
              text: '이용안내',
            },
            {
              link: '/p/Reservguidance',
              text: '예약안내',
            },
            {
              link: '/p/Feeguidance',
              text: '요금안내',
            },
          ],
        },
        {
          topMenu: 'GOLF COURSE',
          // topMenu: '골프코스',
          subMenu: [
            {
              link: '/p/Course',
              text: '전체 코스',
            },
            {
              link: '/p/Course/1',
              text: 'EAST 코스',
            },
            {
              link: '/p/Course/2',
              text: 'WEST 코스',
            },
            {
              link: '/p/Course/3',
              text: 'NORTH 코스',
            },
          ],
        },
        {
          topMenu: 'FACILITIES',
          // topMenu: '주변시설',
          subMenu: [
            {
              link: '/p/Sauna',
              text: '사우나·락카',
            },
            {
              link: '/p/Proshop',
              text: '프로샵',
            },
            {
              link: '/p/Golfpractice',
              text: '어프로치 존',
            },
            {
              link: '/p/Banquethall',
              text: '연회장',
            },
          ],
        },
        {
          topMenu: 'DINING',
          // topMenu: '식사&숙소',
          subMenu: [
            {
              link: '/p/Restaurant',
              text: '레스토랑',
            },
            {
              link: '/p/GrBBQ',
              text: '그린사이드 BBQ',
            },
            {
              link: '/p/Starthouse',
              text: '스타트하우스',
            },
          ],
        },
        {
          topMenu: 'RESERVATION',
          // topMenu: '골프예약',
          subMenu: [
            {
              link: '/p/Preregistration',
              text: '사전접수',
            },
            {
              link: '/p/Waitingreception',
              text: '잔여접수',
            },
            // {
            //   link: '/p/Realtimebooking',
            //   text: '실시간예약',
            // },
            // {
            //   link: '/p/RealtimebookingDining',
            //   text: '다이닝예약',
            // },
            // {
            //   link: '/p/GuestReservResult',
            //   text: '다이닝예약확인',
            // },
          ],
        },
        // {
        //   topMenu: 'SPECIAL OFFERS',
        //   // topMenu: '특별주문',
        //   subMenu: [
        //     {
        //       link: '/p/Pleisure',
        //       text: 'P-LEISURE',
        //     },
        //   ],
        // },
        // '',
        // '',
        // '',
        // '',
        // '',
        // '',
      ],
      headers_en: [
        {
          topMenu: 'ABOUT',
          // topMenu: '클럽소개',
          subMenu: [
            {
              link: '/p/introduce',
              text: 'Brand Story',
              /*text: this.$t('menu1'),*/
            },
            {
              link: '/p/Awards',
              text: 'Awards',
            },
            {
              link: '/p/Tournament',
              text: 'Tournament',
            },
            {
              link: '/p/Photoview',
              text: 'LOCATION',
            },
          ],
        },
        {
          topMenu: 'OPERATION GUIDE',
          // topMenu: '이용안내',
          subMenu: [
            {
              link: '/p/Infoguidance',
              text: 'Operation Guide',
            },
            {
              link: '/p/Reservguidance',
              text: 'Reservation Guide',
            },
            {
              link: '/p/Feeguidance',
              text: 'Rate Information',
            },
          ],
        },
        {
          topMenu: 'GOLF COURSE',
          // topMenu: '골프코스',
          subMenu: [
            {
              link: '/p/Course',
              text: 'The Whole Course',
            },
          ],
        },
        {
          topMenu: 'FACILITIES',
          // topMenu: '주변시설',
          subMenu: [
            {
              link: '/p/Sauna',
              text: 'Locker & Sauna',
            },
            {
              link: '/p/Proshop',
              text: 'Proshop',
            },
            {
              link: '/p/Golfpractice',
              text: 'Approach Zone',
            },
            {
              link: '/p/Banquethall',
              text: 'Banquet Hall',
            },
          ],
        },
        {
          topMenu: 'DINING',
          // topMenu: '식사&숙소',
          subMenu: [
            {
              link: '/p/Restaurant',
              text: 'Restaurant',
            },
            {
              link: '/p/GrBBQ',
              text: 'Greenside BBQ',
            },
            {
              link: '/p/Starthouse',
              text: 'Start House',
            },
          ],
        },
      ],
      headers_jp: [
        {
          topMenu: 'ABOUT',
          // topMenu: '클럽소개',
          subMenu: [
            {
              link: '/p/introduce',
              text: 'ゴルフクラブ紹介',
              /*text: this.$t('menu1'),*/
            },
            {
              link: '/p/Awards',
              text: 'アワーズ',
            },
            {
              link: '/p/Tournament',
              text: 'トーナメント',
            },
            {
              link: '/p/Photoview',
              text: 'フォト',
            },
          ],
        },
        {
          topMenu: 'OPERATION GUIDE',
          // topMenu: '이용안내',
          subMenu: [
            {
              link: '/p/Infoguidance',
              text: 'ご利用案内',
            },
            {
              link: '/p/Reservguidance',
              text: '予約のご案内',
            },
            {
              link: '/p/Feeguidance',
              text: '料金のご案内',
            },
          ],
        },
        {
          topMenu: 'GOLF COURSE',
          // topMenu: '골프코스',
          subMenu: [
            {
              link: '/p/Course',
              text: 'コース全体',
            },
          ],
        },
        {
          topMenu: 'FACILITIES',
          // topMenu: '주변시설',
          subMenu: [
            {
              link: '/p/Sauna',
              text: 'ロッカー＆サウナ',
            },
            {
              link: '/p/Proshop',
              text: 'プロショップ',
            },
            {
              link: '/p/Golfpractice',
              text: 'ゴルフ練習場',
            },
            {
              link: '/p/Banquethall',
              text: '宴会場',
            },
          ],
        },
        {
          topMenu: 'DINING',
          // topMenu: '식사&숙소',
          subMenu: [
            {
              link: '/p/Restaurant',
              text: 'レストラン',
            },
            // GrBBQ 임시 히든처리(2025년 5월 8일까지)
            // {
            //   link: '/p/GrBBQ',
            //   text: 'グリーンサイドBBQ',
            // },
            {
              link: '/p/Starthouse',
              text: 'スタートハウス',
            },
          ],
        },
      ],
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters['Auth/isLoggedIn'];
    },
    selectedNumberMember() {
      return this.$store.getters['Auth/selectedMember'];
    },
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.headers = this.getHeaderHidden();
      } else if (newVal === 'en') {
        this.headers = this.headers_en;
      } else if (newVal === 'ja') {
        this.headers = this.headers_jp;
      } else {
        this.headers = this.getHeaderHidden();
      }
    },
    isShowHiddenMenu() {
      console.log('isLogin:', this.isLogin);
      if (!this.isLogin) return false;
      const memInfo = this.selectedNumberMember;
      console.log('memInfo:', memInfo);
      if (!memInfo) return false;
      if (!isGolfReservEnter(memInfo.memType, memInfo.guestType)) return false;
      return true;
    },
    // getHeaderHidden() {
    //   let headers_ko_hidden = [];
    //   for (let i = 0; i < this.headers_ko.length; i++) {
    //     //골프예약 메뉴 계정상태에따라 hidden
    //     let subMenuHidden = this.headers_ko[i].subMenu;
    //     if (this.headers_ko[i].topMenu === 'RESERVATION' && !this.isShowHiddenMenu()) {
    //       subMenuHidden = this.headers_ko[i].subMenu.filter(
    //         x => x.link !== '/p/Preregistration' && x.link !== '/p/Waitingreception',
    //       );
    //     }
    //     headers_ko_hidden.push({
    //       topMenu: this.headers_ko[i].topMenu,
    //       subMenu: subMenuHidden,
    //     });
    //   }
    //   return headers_ko_hidden;
    // },

    // 비로그인 상태 시 에약 메뉴 hidden
    getHeaderHidden() {
      let headers_ko_hidden = [];
      for (let i = 0; i < this.headers_ko.length; i++) {
        //골프예약 메뉴 계정상태에따라 hidden
        let subMenuHidden = this.headers_ko[i].subMenu;
        if (this.headers_ko[i].topMenu === 'RESERVATION' && !this.isShowHiddenMenu()) {
          subMenuHidden = this.headers_ko[i].subMenu.filter(
            x => x.link !== '/p/Preregistration' && x.link !== '/p/Waitingreception',
          );
        } else {
          headers_ko_hidden.push({
            topMenu: this.headers_ko[i].topMenu,
            subMenu: subMenuHidden,
          });
        }
      }
      return headers_ko_hidden;
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
    $route(to, from) {
      this.refreshLocale(this.$i18n.locale);
      console.log('INDEX-WATCH', to, from);
      if (to.path === '/p/Waitingreception' || to.path === '/p/Preregistration') {
        this.isReservation = true;
      } else {
        this.isReservation = false;
      }
    },
    isLogin(newVal) {
      //console.log('isLogin:', newVal);
      this.headers = this.getHeaderHidden();
    },
    selectedNumberMember(newVal) {
      //console.log('selectedNumberMember:', newVal);
      this.headers = this.getHeaderHidden();
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
    if (this.$route.path === '/p/Waitingreception' || this.$route.path === '/p/Preregistration') {
      this.isReservation = true;
    } else {
      this.isReservation = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.contents {
  padding-bottom: 5rem;
}
.webFooter {
  display: block;
}
.mobileFooter {
  display: none;
}

.hidden {
  display: none;
}
@media (max-width: 992px) {
  .webFooter {
    display: none;
  }
  .mobileFooter {
    display: block;
  }
}
</style>
